import React from 'react';
import { Row, Col, FormGroup, Label, Input } from 'reactstrap';

function ShareholderWrapper({ shareholder, formValueChange, check, countryList, updateListFunction }) {

    const uploadFileHandler = (e, uploadFileName) => {
        const maxFileSize = 5 * 1024 * 1024; // 2 MB in bytes

        const fileExtension = ['jpg', 'jpeg', 'png', 'pdf', 'heic'];
        const fileName = e.target.value;
        const file = e.target.files[0];
        const fileExtensionCheck = fileName.split('.').pop().toLowerCase();

        if (file) {
            if (file.size > maxFileSize) {
                alert('File size exceeds the limit of 5 MB.');
                e.target.value = '';
                formValueChange('step4', e.target.name, e.target.value);
            } else if (fileExtension.includes(fileExtensionCheck)) {
                updateListFunction(uploadFileName, [e.target.files[0]]);
                formValueChange('step4', e.target.name, e.target.value);
            } else {
                alert('Please Upload files with extension jpg, jpeg, png, pdf, heic');
                e.target.value = '';
                formValueChange('step4', e.target.name, e.target.value);
            }
        }
    };

    return (
        <div className="justify w-100" style={{ marginBlock: "10px" }}>
            <h6 className="text-start">Shareholder Representative</h6>
            <Row>
                <Col md={6}>
                    <FormGroup>
                        <Label>Full Name</Label>
                        <Input
                            className={"form-control " + (check && !shareholder.fullName && 'is-invalid')}
                            type="text"
                            value={shareholder.fullName}
                            onChange={(e) => formValueChange('step4', 'fullName', e.target.value)}
                            placeholder="John" />
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup>
                        <Label>Job Title</Label>
                        <Input
                            className={"form-control " + (check && !shareholder.jobTitle && 'is-invalid')}
                            type="text"
                            value={shareholder.jobTitle}
                            onChange={(e) => formValueChange('step4', 'jobTitle', e.target.value)}
                            placeholder="Mr/Mrs" />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md={6}>
                    <FormGroup>
                        <Label>Email</Label>
                        <Input
                            className={"form-control " + (check && !shareholder.email && 'is-invalid')}
                            type="email"
                            placeholder="john@gmail.com"
                            value={shareholder.email}
                            onChange={(e) => formValueChange('step4', 'email', e.target.value)} />
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup>
                        <Label>Country of Residence</Label>
                        <Input
                            className={"mb-3 " + (check && !shareholder.country && 'is-invalid')}
                            type="select"
                            name="country"
                            onChange={(e) => formValueChange('step4', 'country', e.target.value)}
                            value={shareholder.country} // Set the value to the selected country name
                        >
                            <option value="">-- Select --</option>
                            {countryList.map((item, index) => (
                                <option key={index} value={item.value}>
                                    {item.value}
                                </option>
                            ))}
                        </Input>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md={4}>
                    <FormGroup>
                        <Label>Proof of Identity</Label>
                        <Input
                            className={"form-control " + (check && !shareholder.proofOfIdentity && 'is-invalid')}
                            type="file"
                            accept=".jpg, .jpeg, .png, .pdf, .heic"
                            name='proofOfIdentity'
                            onChange={(e) => uploadFileHandler(e, 'SHAREHOLDER_PROOF_OF_ID_0')} />
                    </FormGroup>
                </Col>
                <Col md={4}>
                    <FormGroup>
                        <Label>Proof of Identity Back</Label>
                        <Input
                            // className={"form-control " + (check && !shareholder.proofOfIdentityBack && 'is-invalid')}
                            type="file"
                            accept=".jpg, .jpeg, .png, .pdf, .heic"
                            name='proofOfIdentityBack'
                            onChange={(e) => uploadFileHandler(e, 'SHAREHOLDER_PROOF_OF_ID_BACK_0')} />
                    </FormGroup>
                </Col>
                <Col md={4}>
                    <FormGroup>
                        <Label>Residential Proof of Address</Label>
                        <Input
                            className={"form-control " + (check && !shareholder.proofOfAddress && 'is-invalid')}
                            type="file"
                            accept=".jpg, .jpeg, .png, .pdf, .heic"
                            name='proofOfAddress'
                            onChange={(e) => uploadFileHandler(e, 'SHAREHOLDER_PROOF_OF_ADDRESS_0')} />
                    </FormGroup>
                </Col>
            </Row>
        </div>
    )
}

export default ShareholderWrapper
